import {
  IconBulbFilled,
  IconInfoCircleFilled,
  IconLoader2,
} from "@tabler/icons-react";
import React, { useRef, useState } from "react";
import { applyLoan, handlePayDeposit } from "../../services/user.services";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

const AfterAdmit = () => {
  // Separate state variables for each country button
  const [usaMessage, setUsaMessage] = useState("");
  const [germanyMessage, setGermanyMessage] = useState("");
  const [isUsaLoading, setIsUsaLoading] = useState(false);
  const [isGermanyLoading, setIsGermanyLoading] = useState(false);
  const [isDepositLoading, setIsDepositLoading] = useState(false);
  const depositRef = useRef(null);

  const scrollToDeposit = () => {
    depositRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // This function now checks the country parameter and updates the corresponding state.
  const handleApplyNow = async (country) => {
    // Set loading state based on country
    if (country === "USA") {
      setIsUsaLoading(true);
    } else if (country === "Germany") {
      setIsGermanyLoading(true);
    }

    const loanData = {
      country_proof: country, // Pass the country name correctly
    };

    try {
      const response = await applyLoan(loanData); // Call the service

      // Update the message state based on the country value.
      if (country === "USA") {
        setUsaMessage(
          response.status ||
            "Proof of finances are required to be shown for i20. Need i20 financing from Avanse?\n\nClick Here"
        );
      } else if (country === "Germany") {
        setGermanyMessage(
          response.status ||
            "Opening of blocked account is compulsory for Visa purposes."
        );
      }
    } catch (error) {
      console.error("Error applying for loan:", error);
      const errorMsg =
        error.response?.data?.error || "An error occurred. Please try again.";
      if (country === "USA") {
        setUsaMessage(errorMsg);
      } else if (country === "Germany") {
        setGermanyMessage(errorMsg);
      }
    } finally {
      // Reset loading state
      if (country === "USA") {
        setIsUsaLoading(false);
      } else if (country === "Germany") {
        setIsGermanyLoading(false);
      }
    }
  };

  const handlePayToDeposit = async () => {
    setIsDepositLoading(true);
    try {
      const res = await handlePayDeposit();
      toast.success(
        "You have successfully applied for Pay Deposit To The University"
      );
    } catch (err) {
      toast.error("Failed");
    } finally {
      setIsDepositLoading(false);
    }
  };

  return (
    <>
      <div className="flex flex-wrap bg-blue-200 justify-center gap-5 p-4 w-full">
        <div className="bg-white p-4 sm:p-6 rounded-md shadow-md h-auto space-y-4 w-full md:w-11/12 lg:w-10/12">
          <div className="flex items-center">
            <IconBulbFilled stroke={2} className="flex-shrink-0" />
            <h3 className="text-lg font-semibold text-gray-800 ml-2">
              Congratulations on your Admit
            </h3>
          </div>
          <p className="text-gray-600 p-2 max-w-screen h-auto overflow-auto text-sm sm:text-base">
            Congratulations on getting admitted to your dream university. Please
            carefully go through the next steps after admit - <br></br>
            <b>Step 1- </b>
            Understand the conditions in the offer and fulfill the same. Try to
            extend the deposit payment deadlines (sample mail in{" "}
            <Link to={"/student/resources"} className="underline text-blue-600">
              <b>Resources Tab</b>
            </Link>
            ) Ask for Scholarships/Increase in Scolarships (sample mail in{" "}
            <Link to={"/student/resources"} className="underline text-blue-600">
              <b>Resources Tab</b>
            </Link>
            ). <br></br> <b>Step 2-</b> Prepare for finances through{" "}
            <Link
              to={"/student/mainForex/education-loan"}
              className="underline text-blue-600"
            >
              <b> Education Loan</b>
            </Link>
            /Self Funds Start with{" "}
            <Link
              to={"/student/mainForex/education-loan"}
              className="underline text-blue-600"
            >
              <b> Education Loan</b>
            </Link>{" "}
            process at the earliest as most banks allow change of university
            later. We can help get lower rates and processing fee on most banks,
            <Link to={"/student/resources"} className="underline text-blue-600">
              <b>Click</b>
            </Link>{" "}
            to know more Start looking at{" "}
            <Link
              to={"/student/mainForex/accomodations"}
              className="underline text-blue-600"
            >
              <b>Accommodation</b>
            </Link>
            ,
            <Link
              to={"/student/mainForex/insurance"}
              className="underline text-blue-600"
            >
              <b>Insurance</b>
            </Link>{" "}
            and{" "}
            <Link onClick={scrollToDeposit} className="underline text-blue-600">
              <b>Deposit Payment Options</b>
            </Link>
            . Refer to the button to get options at{" "}
            <Link to={"/student/resources"} className="underline text-blue-600">
              <b>Discounted Rates</b>
            </Link>
            . Pro TIP- Deposit Payment through forex agencies can help reduce
            forex charges tremendously.
            <Link
              to={"/student/mainForex/forex"}
              className="underline text-blue-600"
            >
              <b>Click</b>
            </Link>{" "}
            to know more.
            <br></br>
            <b>Step 3-</b> Decide on the Final University option after
            discussion with your counselor Deposit payment to secure your seat
            at the earliest after finalization Email/connect with university to
            understand any specific steps to be taken Pro TIP- You can try
            arranging an online call with the admissions advisor to understand
            more about scholarships, courses, future prospects etc.<br></br>{" "}
            <b>Step 4-</b> Ideal time to start preparing for Visa process is 4-6
            months before your course start date Start preparing visa documents
            according to the details mentioned in the{" "}
            <Link
              to={"/student/visa_process"}
              className="underline text-blue-600"
            >
              <b>Visa Section</b>
            </Link>
            .
          </p>
          <div className="p-3 sm:p-6 space-y-6 text-gray-800 text-sm sm:text-md leading-relaxed">
            <div>
              <h2 className="font-semibold text-md mb-2">
                Country Specific Info -
              </h2>

              <h3 className="font-semibold text-gray-900 mt-4">USA</h3>
              <p>
                i20 document is required for visa filing - You need to show
                funds worth tuition fees of 1 year along with living expenses.
              </p>
              <p>
                Bank statements/Bank balance certificate{" "}
                <span className="italic">
                  (sample in{" "}
                  <Link
                    to={"/student/resources"}
                    className="underline text-blue-600"
                  >
                    <b>Resources Tab</b>
                  </Link>
                  )
                </span>
                /Education loan Sanction letters
                <span className="italic">
                  {" "}
                  (sample in{" "}
                  <Link
                    to={"/student/resources"}
                    className="underline text-blue-600"
                  >
                    <b>Resources Tab</b>
                  </Link>
                  )
                </span>
                /Liquid FDs are allowed here as valid proof of funds.
              </p>
              <p>
                For the total amount of i20, kindly refer to your application
                portal/mail from the university/Offer letter for these details.
              </p>
              <p className="italic font-medium text-purple-700">
                Pro TIP - If you require help for arrangement of funds for i20 -{" "}
                <Link
                  // to={"/student/resources"}
                  className="underline text-blue-600"
                >
                  <b>Get In Touch With Your Aara Counselor</b>
                </Link>{" "}
              </p>
              <div className="bg-gray-100 m-2 sm:m-4 p-3 sm:p-4 rounded-md flex flex-col sm:flex-row justify-start items-center shadow-sm gap-2">
                <div className="shrink-0">
                  <IconInfoCircleFilled stroke={2} />
                </div>
                <div className="flex items-start flex-1 text-center sm:text-left my-2 sm:my-0">
                  <p className="text-gray-700">
                    In case of USA, Proof of finances are required to be shown
                    for i20. Need i20 financing from Aara Consultancy?
                  </p>
                </div>
                <button
                  onClick={() => handleApplyNow("USA")}
                  className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition flex items-center justify-center w-full sm:w-auto"
                  disabled={isUsaLoading}
                >
                  {isUsaLoading ? (
                    <>
                      <IconLoader2 className="animate-spin mr-2" size={18} />
                      Processing...
                    </>
                  ) : (
                    "Click Here"
                  )}
                </button>
              </div>
              {usaMessage && (
                <p className="mt-4 text-base sm:text-lg text-green-500">
                  {usaMessage}
                </p>
              )}
              <h3 className="font-semibold text-gray-900">
                Proof of Finances Button
              </h3>
              <p>
                For USA universities, to obtain your i20 anyone can be your
                sponsor including us. In case you do not have the funds ready or
                wish to have the finances shown for you - we can become your
                sponsor at nominal charges and help you obtain the i20 at the
                earliest by showing our financial statements to the university.
                <span className="text-blue-600 font-medium cursor-pointer">
                  Click
                </span>{" "}
                to know more about the details.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-gray-900">UK</h3>
              <p>CAS letter is required in case of UK for visa filing.</p>
              <p>
                For CAS letter - You need to show funds of 1 year of Living (as
                per location) and tuition cost.
              </p>
              <p>Many universities give the CAS even without showing funds.</p>
              <p>
                CAS letter will be generated only when all conditions of offer
                are met.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-gray-900">
                Rest of the countries
              </h3>
              <p>
                Some countries require documents like{" "}
                <span className="font-semibold">
                  {" "}
                  <Link
                    // to={"/student/resources"}
                    className="underline text-blue-600"
                  >
                    <b>Blocked Account (Germany)</b>
                  </Link>
                </span>
                ,GIC (Canada) and Insurances in Europe and Australia etc.
                Details are mentioned in Visa Tab.
              </p>
              <p>
                We can start with visa filing for these countries after
                unconditional offer letter is received.
              </p>
              <div className="bg-gray-100 m-2 sm:m-4 p-3 sm:p-4 rounded-md flex flex-col sm:flex-row justify-start items-center shadow-sm gap-2">
                <div className="shrink-0">
                  <IconInfoCircleFilled stroke={2} />
                </div>
                <div className="flex items-start flex-1 text-center sm:text-left my-2 sm:my-0">
                  <p className="text-gray-700">
                    For Germany, Opening of blocked account and For Canada,
                    opening of GIC (Guaranteed Investment Certificate) is
                    compulsory for Visa purposes.
                  </p>
                </div>
                <button
                  onClick={() => handleApplyNow("Germany")}
                  className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition flex items-center justify-center w-full sm:w-auto"
                  disabled={isGermanyLoading}
                >
                  {isGermanyLoading ? (
                    <>
                      <IconLoader2 className="animate-spin mr-2" size={18} />
                      Processing...
                    </>
                  ) : (
                    "Click Here to open a Blocked/GIC Account"
                  )}
                </button>
              </div>
              {germanyMessage && (
                <p className="mt-4 text-base sm:text-lg text-green-500">
                  {germanyMessage}
                </p>
              )}
            </div>

            <div>
              <h3 className="font-semibold text-gray-900">
                Blocked Account Button
              </h3>
              <p>
                Blocked Account is compulsory to file visa for Germany. Funds
                have to be deposited in that account which can be withdrawn
                monthly once you land there.
                <span className="text-blue-600 font-medium cursor-pointer">
                  Click
                </span>{" "}
                to start the process now.
              </p>
            </div>
          </div>
        </div>
        <div
          className="flex flex-col sm:flex-row justify-between items-center bg-white p-4 sm:p-8 rounded-md shadow-md w-full md:w-11/12 lg:w-10/12 gap-3 sm:gap-5"
          ref={depositRef}
        >
          <h3 className="text-lg font-semibold text-gray-800 text-center sm:text-left">
            Pay Deposit to the University
          </h3>
          <button
            className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition m-0 w-full sm:w-auto flex items-center justify-center"
            onClick={handlePayToDeposit}
            disabled={isDepositLoading}
          >
            {isDepositLoading ? (
              <>
                <IconLoader2 className="animate-spin mr-2" size={18} />
                Processing...
              </>
            ) : (
              "Pay Deposit to the University"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default AfterAdmit;
